var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"form__error"},[_c('ErrorIcon',{staticClass:"form__error-icon",attrs:{"width":"20px","height":"16.5px"}}),_vm._v("\n  "+_vm._s(_vm.msg)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }